const fields = [
  {
    name: "companyName",
    label: "Company Name",
    disabled: true,
    value: "companyName",
    select: true,
  },
  {
    name: "siteId",
    label: "Site Name",
    required: true,
    disabled: true,
    select: true,
    validationType: "number",
  },
  {
    name: "title",
    label: "Plan Title",
    required: true,
    validationType: "string",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "price",
    label: "Price",
    required: true,
    validationType: "number",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "duration",
    label: "Duration",
    required: true,
    validationType: "number",
    placeholder: "HH:MM",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
  {
    name: "isActive",
    label: "Member Plan Status",
    switch: true,
    required: true,
    validationType: "boolean",
    validations: [
      {
        type: "required",
        params: ["this field is required"],
      },
    ],
  },
];
  
  export default fields;
  